import React, { useEffect, useState } from 'react';
import * as Request from '../../common/request';
import * as Const from '../../common/const';
import { DatePicker, ActionSheet, ImageUploader, Selection, Card, Form, Input, Space, Toast, Button } from 'antd-mobile'
import './index.less';

const statusList = [
	{ text: '营业中', key: '1' },
	{ text: '停业中', key: '2' },
]
const PageModel = props => {
	const [form] = Form.useForm();
	const [img, setImg] = useState('');

	const [companyId, setCompanyId] = useState(0);
	const [values, setValues] = useState(false);
	const [areaList, setAreaList] = useState([]);
	const [visible_area, setVisibleArea] = useState(false);

	const [values_status, setValueStatus] = useState(false);
	const [visible_status, setVisibleStatus] = useState(false);

	const [status, setStatus] = useState('');
	const [subStreet, setSubStreet] = useState('');

	const getDetail = async (array) => {
		const { id } = props.match.params;
		setCompanyId(id)
		console.log('传过来的====;', id);

		const result = await Request.get({
			url: '/company/detail',
			data: {
				id: id
			}
		});
		console.log(result);
		if (!result) return;
		setSubStreet(result.data.subStreet)
		setStatus(result.data.status)
		setValues(array.filter((item) => { return item.key == result.data.status })[0].text)
		setValueStatus(statusList.filter((item) => { return item.key == result.data.status })[0].text)
		setImg(result.data.companyfile ? result.data.companyfile : '');
		console.log('1-1-1-1===', result.data);
		form.setFieldsValue({
			enterpriseName: result.data.enterpriseName,
			companyName: result.data.companyName,
			companyHead: result.data.companyHead,
			companyTel: result.data.companyTel,
			address: result.data.address,
			companyfile: result.data.companyfile
		});
	};

	const getAreaList = async () => {
		const result = await Request.get({
			url: '/area/list'
		});
		if (!result) return;

		const list = result.data.list || [];
		let array = [];
		for (let index = 0; index < list.length; index++) {
			array.push({ "text": list[index].areaName, "key": list[index].id });
		}
		console.log('array=', array);
		setAreaList(array);

		//如果是编辑模式，则获取数据
		if (props.match.params.id != 0) {
			console.log('编辑模式');
			await getDetail(array)
		}
	};

	useEffect(() => {
		//获取街道列表
		async function fetchData() {
			await getAreaList();
		}
		fetchData();
	}, [123]);

	//图片上传
	const uploadHandle = async (e, idx) => {
		const selectedFile = e.target.files[0];
		const formData = new FormData();
		formData.append('file', selectedFile);
		const result = await Request.uploadFetch({
			url: '/problem/upload',
			method:'POST',
			data: formData
		});
		if(!result) return;
		const src = result.data.src;
		console.log('上传图片的src===', src);
		// img= src;
		form.setFieldsValue({
			companyfile: src
		});
		setImg(src);
	};

	const onFinish = async (values) => {
		if (!values.enterpriseName || !values.companyName || !values.companyHead || !values.companyTel || !values.address || !subStreet || !status) {
			Toast.show('请填写完整信息');
			return;
		}
		let url = '/company/update';
		if (companyId) {
			url = '/company/update';
			values = { ...values, id: companyId }
		} else {
			url = '/company/add';
		}
		const result = await Request.post({
			url: url,
			data: {
				...values,
				subStreet: subStreet,
				status: status,
			}
		});
		console.log(result);
		if (result) {
			Toast.show('提交成功')
			props.history.goBack(-1)
		}
	}
	return (
		<Form layout='vertical' style={{ padding: '10px' }}
			onFinish={onFinish}
			form={form}
			footer={
				<Button block type='submit' style={{ backgroundColor: '#00C249', fontSize: '16px', color: '#fff' }} size='large'>
					提交
				</Button>
			}>
			<Form.Item label='企业名称' name='enterpriseName' required={true}>
				<Input placeholder='请输入' clearable />
			</Form.Item>
			<Form.Item label='店铺名称' name='companyName' required={true}>
				<Input placeholder='请输入' clearable />
			</Form.Item>

			<Form.Item label='店铺负责人' name='companyHead' required={true}>
				<Input placeholder='请输入' clearable />
			</Form.Item>

			<Form.Item label='负责人电话' name='companyTel' required={true}>
				<Input placeholder='请输入(必须是电话号码)' clearable maxLength={11} minLength={11} />
			</Form.Item>

			<Form.Item label='地址' name='address' required={true}>
				<Input placeholder='请输入' clearable />
			</Form.Item>
			{areaList.length > 0 && <Form.Item label='所属街道' name='subStreet' required={true}>
				<Button onClick={() => setVisibleArea(true)}>请选择</Button>
				<label>{values}</label>
				<ActionSheet
					visible={visible_area}
					actions={areaList}
					onClose={() => setVisibleArea(false)}
					onAction={action => {
						setVisibleArea(false)
						setValues(action.text)
						setSubStreet(action.key)
					}}
				/>
			</Form.Item>}

			<Form.Item label='营业状态' name='status' required={true}>
				<Button onClick={() => setVisibleStatus(true)}>请选择</Button>
				<label>{values_status}</label>
				<ActionSheet
					visible={visible_status}
					actions={statusList}
					onClose={() => setVisibleStatus(false)}
					onAction={action => {
						setVisibleStatus(false)
						setValueStatus(action.text)
						setStatus(action.key)
					}}
				/>
			</Form.Item>
			<Form.Item label='店铺门脸照' name='companyfile'>
				<div className="picture-wrap">
					{
					 <div className="item">
							{img && <img src={Const.imgPrefix + img } />}
							{img && <div className="close" onClick={() => {
								setImg('');
								form.setFieldsValue({
									companyfile: ''
								});
							}} />}
							<input type="file" accept="image/*" onChange={(e) => {
								uploadHandle(e);
							}} />
						</div>
					}
				</div>

			</Form.Item>
		</Form>
	);
};

export default PageModel;
